export default "__VITE_ASSET__BlEL7NRw__"